module.exports = __webpack_public_path__ + "static/media/esg_schema_de.95839d6c.svg";